module.exports = __webpack_public_path__ + "static/media/request-eligibility-icon.2d73bc6f.svg";